import { getEventById, getSomeEvents } from './locateEvents';

const { GoogleSpreadsheet } = require('google-spreadsheet');
const { default: sheetsConfig } = require('../sheetsConfig');

async function getSheet(){
    const doc = new GoogleSpreadsheet(sheetsConfig.spreadsheet_id);

    await doc.useServiceAccountAuth({
        // env var values are copied from service account credentials generated by google
        // see "Authentication" section in docs for more info
        client_email: sheetsConfig.client_email,
        private_key: sheetsConfig.private_key,
      });

    await doc.loadInfo();

    const sheet = doc.sheetsByTitle["Growthify"]

    return sheet
}

function getHeaderRow(context){

    let headers = []
    let ids = []

    let forms = context.timedEvents.form
    let habits = context.timedEvents.habit

    for(let form in forms){
        form = forms[form]
        for(let field in form.formData){
            headers.push(field)
            ids.push(form._id)
        }
    }

    for(let habit in habits){
        habit = habits[habit]
        headers.push(habit.name)
        ids.push(habit._id)
    }

    return {headers, ids}

}

async function updateHeaderRow(sheet, context){
    await sheet.loadHeaderRow()

    const correctValues = getHeaderRow(context)
    const ids = correctValues.ids
    const correctHeaders = correctValues.headers
    const sheetHeaders = sheet.headerValues
    let finalHeaders = sheetHeaders

    if (correctHeaders !== sheetHeaders){
        for (let index = 0; index < sheetHeaders.length; index++) {
            const header = sheetHeaders[index];
            if (correctHeaders.includes(header)){

            }
            else{
                if(!(finalHeaders[index].startsWith('---'))){
                    finalHeaders[index] = "---" + header
                }
                if(!(header.includes("Date")) && !(header.includes("Todo Pct")) && !(header.includes("# of Todos"))){
                    ids.splice(index, 0, '---')
                }
            }
            
        }
        for (let index = 0; index < correctHeaders.length; index++) {
            const header = correctHeaders[index];
            if (!(sheetHeaders.includes(header))){
                finalHeaders.push(header)
            }
            
        }
    }

    await sheet.loadCells({startRowIndex: 0, endRowIndex: 1, startColumnIndex:0, endColumnIndex: finalHeaders.length})
    for (let index = 0; index < finalHeaders.length; index++) {
        const header = finalHeaders[index];
        let cell = sheet.getCell(0, index)
        cell.value = header
        await sheet.saveUpdatedCells();
        
    }
    // await sheet.setHeaderRow(finalHeaders)

    return {finalHeaders, ids}

}

async function updateSheet(context){
    const sheet = await getSheet()
    let headerData = await updateHeaderRow(sheet, context)
    let headers = headerData.finalHeaders
    headers.splice(0, 3)
    let ids = headerData.ids

    let todos = getSomeEvents(context, 'todo')
    let todoPct = 0
    for(let todo in todos){
        if(todos[todo].checkedHistory[0]){
            todoPct += 1
        }
    }

    let nTodos = Object.keys(todos).length
    todoPct /= nTodos

    let date = new Date()
    // let values = {
    //     '---Date' : date.getDay() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear(),
    //     '---Todo Pct': todoPct
    // }

    let values = [date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear(), todoPct * 100, nTodos]

    for (let index = 0; index < headers.length; index++) {
        const header = headers[index];
        const id = ids[index]

        let value = 'NA'

        if (id !== '---'){
            const event = getEventById(context, id)
            
            if(event.type === "habit"){
                value = event.checkedHistory[0]
            }
            else{
                value = event.formData[header][0]
            }
        }

        // values[header] = value
        values.push(value)
        
    }

    console.log(values)
    sheet.addRow(values)

}

// async function callUpdateSheet(getContext){
//     setInterval(async () => {
//         let now = new Date()
//         let timeTo12 = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 57, 0, 0) - now
//         const context = getContext()
//         console.log(context)
//         if (Math.abs(timeTo12) < 1000 * 60){
//             const context = getContext()
//             await updateSheet(context)
//         }
//     }, 1000 * 60)

// }

export default updateSheet